import Button from "react-bootstrap/Button";

const SecondaryButton = ({ children, onClick, ...props }) => {
  const { className } = props;
  if (className) {
    delete props["className"];
  }

  return (
    <Button
      className={`${className} secondary-btn`}
      type="button"
      onClick={onClick}
      {...props}
    >
      {children}
    </Button>
  );
};

export default SecondaryButton;
